import { JointHook } from './joint.hook';

export class TradingExperienceHook extends JointHook {

  static paths = [
    'FinancialInformation.isExperienced',
    'JointAccountFinancialInformation.isExperienced'
  ];

  static execute(path, value, actions) {
    const basePath = path.match(/^FinancialInformation/) ? 'FinancialInformation' : 'JointAccountFinancialInformation';

    const pathsToDelete = [
      'stockYears',
      'stockAnnualTrades',
      'stockAverageTradeSize',
      'optionYears',
      'optionAnnualTrades',
      'optionAverageTradeSize'
    ];

    if (value === false) {
      for (const path of pathsToDelete) {
        actions.deleteData(`${basePath}.${path}`);
      }
    }
  }
}
